import {styled} from '@mui/material/styles'
import { TableRow } from '@mui/material'

const StyledTableRow = styled(TableRow)(({theme}) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: '#ffffff',
  },
  '&:nth-of-type(even)': {
    backgroundColor: '#f2f2f2',
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
  '.schedule-survey-btn': {
    color: '#E84F6B',
  },
  '.schedule-survey-btn:hover': {
    backgroundColor: 'transparent',
  },
}))

export default StyledTableRow
